export const DefaultDateTimeFormatOptions = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
};

export const DefaultDateFormatOptions = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
};